import { render, staticRenderFns } from "./HomeAds.vue?vue&type=template&id=18e0789c&scoped=true"
import script from "./HomeAds.vue?vue&type=script&lang=js"
export * from "./HomeAds.vue?vue&type=script&lang=js"
import style0 from "./HomeAds.vue?vue&type=style&index=0&id=18e0789c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e0789c",
  null
  
)

export default component.exports